// Decides what (if anything) Profile's password section renders. Kept
// pure so the matrix can be unit-tested without React/MobX scaffolding.
type PasswordSectionMode = 'hidden' | 'set' | 'change'

interface IPasswordSectionAuth {
  isFromSSO: boolean
  hasPassword: boolean | null
  hasEmail: boolean | null
}

export function getPasswordSectionMode(
  auth: IPasswordSectionAuth,
): PasswordSectionMode {
  if (auth.isFromSSO) return 'hidden'

  // /me hasn't resolved yet — don't flicker a form on the way in.
  if (auth.hasPassword === null || auth.hasEmail === null) return 'hidden'

  // Phone-only users can't meaningfully set a password without an email
  // identifier on the auth record. hasEmail comes from /me and is the
  // authoritative signal — authEmail can be null for phone-OTP sessions
  // even when an email exists on the user account.
  if (!auth.hasEmail) return 'hidden'

  return auth.hasPassword ? 'change' : 'set'
}
